/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */



window.requestAnimFrame = (function () {
	return window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};
})();

var Utils = {};
Utils.addEvent = (function () {
	var filter = function (el, type, fn) {
		for (var i = 0, len = el.length; i < len; i++) {
			utils.addEvent(el[i], type, fn);
		}
	};
	if (document.addEventListener) {
		return function (el, type, fn) {
			if (el && el.nodeName || el === window) {
				el.addEventListener(type, fn, false);
			} else if (el && el.length) {
				filter(el, type, fn);
			}
		};
	}
	return function (el, type, fn) {
		if (el && el.nodeName || el === window) {
			el.attachEvent('on' + type, function () { return fn.call(el, window.event); });
		} else if (el && el.length) {
			filter(el, type, fn);
		}
	};
})();

var docCookies = {
	getItem: function (sKey) {
		if (!sKey) { return null; }
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	},
	setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
		if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
		var sExpires = "";
		if (vEnd) {
			switch (vEnd.constructor) {
				case Number:
					sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
					break;
				case String:
					sExpires = "; expires=" + vEnd;
					break;
				case Date:
					sExpires = "; expires=" + vEnd.toUTCString();
					break;
			}
		}
		document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
		return true;
	},
	removeItem: function (sKey, sPath, sDomain) {
		if (!this.hasItem(sKey)) { return false; }
		document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
		return true;
	},
	hasItem: function (sKey) {
		if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
		return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
	},
	keys: function () {
		var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
		for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
		return aKeys;
	}
};

function shuffle(a) {
	for (let i = a.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}

function getElementIndex(node) {
	var index = 0;
	while ((node = node.previousElementSibling)) {
		index++;
	}
	return index;
}

function getCoords(elem) { // crossbrowser version
	var box = elem.getBoundingClientRect();

	var body = document.body;
	var docEl = document.documentElement;

	var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
	var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

	var clientTop = docEl.clientTop || body.clientTop || 0;
	var clientLeft = docEl.clientLeft || body.clientLeft || 0;

	var top = box.top + scrollTop - clientTop;
	var left = box.left + scrollLeft - clientLeft;

	return { top: Math.round(top), left: Math.round(left) };
}

function scrollToY(o, n) { function a() { t += 1 / 60; var n = t / c, l = i(n); 1 > n ? (requestAnimFrame(a), window.scrollTo(0, r + (o - r) * l)) : window.scrollTo(0, o) } var r = window.scrollY, o = o || 0, n = n || 2e3, t = 0, c = Math.max(.1, Math.min(Math.abs(r - o) / n, .8)), i = function (o) { return -.5 * (Math.cos(Math.PI * o) - 1) }; a() }

function scrollToElement(event, el) {

	event.preventDefault ? event.preventDefault() : (event.returnValue = false);
	//var el = event.target || event.originalTarget || event.srcElement;
	//var elId = '#' + (el.getAttribute("href") || el.href).slice(1);
	//var elId = '#' + el.getAttribute("href").substring(el.getAttribute("href").indexOf('#')+1);
	//el = document.querySelectorAll(elId);
	if (el) {
		//console.log(el);
		var elCoords = getCoords(el);
		var offsetTop = elCoords.top;
		//offsetTop -= document.querySelector('.header').clientHeight;
		/*if ( window.innerWidth >= mobileMenuBreakpoint ) {
			offsetTop -= document.querySelector('.header').clientHeight;
		}*/
		scrollToY(offsetTop, 500);
		return false;
	}
}


function detectIE() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return false;
}
var mobileMenuBreakpoint = 768;

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
	// All pages
	'common': {
		init: function () {
			// JavaScript to be fired on all pages
			var version = detectIE();


			// Ajax svg sprite to page
			/*var ajax = new XMLHttpRequest();
			ajax.open("GET", window.location.protocol + "//" + window.location.host + "/wp-content/themes/base/templates/content-svg.html", true);
			ajax.send();
			ajax.onload = function(e) {
				var div = document.createElement("div");
				div.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;");
				div.innerHTML = ajax.responseText;
				document.body.insertBefore(div, document.body.childNodes[0]);
			};*/

			// Fix horizontal scrolling with 100vw containers on IE and Edge
			function handleWindow() {
				var body = document.querySelector('body');
				if (window.innerWidth > body.clientWidth + 5) {
					body.classList.add('has-scrollbar');
					body.setAttribute('style', '--scroll-bar: ' + (window.innerWidth - body.clientWidth) + 'px');
				} else {
					body.classList.remove('has-scrollbar');
				}
			}

			// trigger scroll to make sure slow networks animate on opening
			setTimeout(function () {
				handleWindow();
				window.dispatchEvent(new Event('scroll'));
			}, 300);


			var mainnav = document.querySelector('.header');
			var scrollTop = window.scrollY;
			var lastScrollTop = 0;
			var scrollTopDelta = 0;
			var scrollDelta = 0;

			function checkHeaderPos() {
				scrollTop = window.scrollY;
				scrollDelta = scrollTop - lastScrollTop;
				if (scrollTop > 40) {
					if (scrollDelta > 0) {
						mainnav.classList.add('scrolled');
					} else {
						mainnav.classList.remove('scrolled');
					}
				} else {
					mainnav.classList.remove('scrolled');
				}
				lastScrollTop = scrollTop; // update last scroll top value
			}
			checkHeaderPos();




			// Make hero images bg for IE11
			if (version == 11 || version == 10) {
				console.log(version);
				var bgImgEls = document.querySelectorAll('.l-container__bg img');
				for (var ii = 0; ii < bgImgEls.length; ii++) {
					var imgContainer = bgImgEls[ii].parentElement;
					var imgUrl = bgImgEls[ii].getAttribute('data-lazy-src');
					if (imgUrl == null) {
						imgUrl = bgImgEls[ii].getAttribute('src');
					}
					imgContainer.setAttribute('style', 'background-image: url(' + imgUrl + ');');
					imgContainer.classList.add('object-fit-ie');
				}
			}

			// Fix object fit for hero videos on IE and Edge
			function fixVideos() {
				// version returns false if anything else than IE or Edge
				if (version !== false) {
					var videoEls = document.querySelectorAll('.l-container__bg--video');
					for (var vi = 0; vi < videoEls.length; vi++) {
						var videoRatio = videoEls[vi].videoWidth / videoEls[vi].videoHeight;
						var wrapWidth = videoEls[vi].parentElement.clientWidth;
						var wrapHeight = videoEls[vi].parentElement.clientHeight;
						var wrapRatio = wrapWidth / wrapHeight;
						var newWidth = '100%';
						var newHeight = '100%';
						if (videoRatio < wrapRatio) {
							newWidth = wrapWidth + 'px';
							newHeight = wrapWidth / videoRatio + 'px';
						} else {
							newWidth = wrapHeight * videoRatio + 'px';
							newHeight = wrapHeight + 'px';
						}
						videoEls[vi].style.width = newWidth;
						videoEls[vi].style.height = newHeight;
					}
				}
			}
			fixVideos();



			// Wrap iframes in responsive div
			var players = [
				'.page-content iframe[src*="youtube.com"]',
				'.page-content iframe[src*="vimeo.com"]',
				'.page-content iframe[src*="google.com/maps"]',
				'.page-content iframe[data-src*="youtube.com"]',
				'.page-content iframe[data-src*="vimeo.com"]',
				'.page-content iframe[data-src*="google.com/maps"]'
			];
			var fitVids = document.querySelectorAll(players.join(","));

			if (fitVids.length) {
				// Loop through videos
				for (var i = 0; i < fitVids.length; i++) {
					// Get Video Information
					var fitVid = fitVids[i];
					var width = fitVid.getAttribute("width");
					var height = fitVid.getAttribute("height");
					var aspectRatio = height / width;
					var parentDiv = fitVid.parentNode;

					// Wrap it in a DIV
					var div = document.createElement("div");
					div.className = "responsive-wrapper";
					div.style.paddingBottom = aspectRatio * 100 + "%";
					parentDiv.insertBefore(div, fitVid);
					fitVid.remove();
					div.appendChild(fitVid);

					// Clear height/width from fitVid
					fitVid.removeAttribute("height");
					fitVid.removeAttribute("width");
				}
			}

			var submenuLinks = document.querySelectorAll('.menu-item-has-children > a');
			//var navigationLinks = document.querySelectorAll('.menu-item > a');
			var pageLinks = document.querySelectorAll('a');
			var inPageLinks = document.querySelectorAll('a[href*="#"]');



			// instantiate the scrollama
			var scroller = scrollama();
			// https://github.com/daneden/animate.css
			// https://github.com/russellgoldenberg/scrollama
			function initScrollama() {
				if (document.querySelector('.js-animate, .l-content-column, .page-content') != null) { // ,

					// setup the instance, pass callback functions
					scroller
						.setup({
							step: '.js-animate, .l-content-column, .l-row, .page-content > *, .base-top-placement, .base-bottom-placement', // ,
							offset: 0.95
						})
						.onStepEnter(function (response) {
							// { element, index, direction }
							response.element.classList.add('animated');


						})
						.onStepExit(function (response) {
							// { element, index, direction }
						});

					// setup resize event
					window.addEventListener("resize", scroller.resize);
				}
			}
			initScrollama();

			function closeNav() {
				if (document.querySelector('body').classList.contains('nav-open')) {
					document.querySelector('.header').classList.remove('nav-open');
					document.querySelector('body').classList.remove('nav-open');
					document.querySelector('.js-toggle-nav').setAttribute('aria-expanded', 'false');
				}
			}
			function toggleNav(e) {
				e.preventDefault();
				if (!document.querySelector('body').classList.contains('nav-open')) {
					document.querySelector('body').classList.add('nav-open');
					document.querySelector('.js-toggle-nav').setAttribute('aria-expanded', 'true');
					setTimeout(function () {
						document.querySelector('.header').classList.add('nav-open');
					}, 500);
				} else {
					closeNav();
				}
			}
			/*var navParents = document.querySelectorAll('.menu-item-has-children > a');
			for (i = 0; i < navParents.length; i++) {
				Utils.addEvent(navParents[i], 'click', function() {

				});
			}*/

			Utils.addEvent(document.querySelector('.js-cookie-settings'), 'click', function (e) {
				e.preventDefault();
				document.querySelector('.qc-cmp2-persistent-link').dispatchEvent(new Event('click'));
			});


			// nav toggle
			Utils.addEvent(document.querySelector('.js-toggle-nav'), 'click', toggleNav);
			Utils.addEvent(document.querySelector('main'), 'click', closeNav);
			Utils.addEvent(document.querySelector('.js-close-nav'), 'click', function (e) {
				e.preventDefault();
				closeNav();
			});

			// scroll to hash
			var hash = window.location.hash;
			if (hash) {
				var target = document.getElementById(hash);
				target = target ? target : document.querySelector('#' + hash.slice(1));
				if (target) {
					scrollToElement(event, target);
				}
			}

			// SUB MENUS
			// Add submenu indicators to menu items
			for (var i = 0; i < submenuLinks.length; i++) {
				var submenuIndicator = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
				submenuIndicator.innerHTML = '<use xlink:href="#t-menu-indicator" />';
				submenuLinks[i].append(submenuIndicator);
			}
			var submenuLinkToggles = document.querySelectorAll('.menu-item-has-children > a svg');

			// Open & close submenus (mobile devices only)
			/*for (var i = 0; i < submenuLinks.length; i++) {
				Utils.addEvent(submenuLinks[i], 'click', function(e) {
					if ( window.innerWidth < mobileMenuBreakpoint ) {
						if ( this.parentElement.classList.contains('active') ) {
							//this.parentElement.classList.remove('active');
						} else {
							e.preventDefault();
							this.parentElement.classList.add('active');
						}
					}
				});
			}
			for (var i = 0; i < submenuLinkToggles.length; i++) {
				Utils.addEvent(submenuLinkToggles[i], 'click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					if (this.parentElement.parentElement.classList.contains('active')) {
						this.parentElement.parentElement.classList.remove('active');
					} else {
						this.parentElement.parentElement.classList.add('active');
					}
				});
			}*/



			// All content links
			var contentLinks = document.querySelectorAll('p a, li a');
			for (var i = 0; i < contentLinks.length; i++) {
				var linkhref = contentLinks[i].getAttribute('href');

				// Add class to all links pointing to image
				if (linkhref != null && (linkhref.indexOf("jpg") > 0 || linkhref.indexOf("png") > 0) && !contentLinks[i].parentElement.classList.contains('als-item')) {
					contentLinks[i].classList.add('js-image-link');
				}

				// add classes to youtube links
				if (linkhref != null) {
					var matches_yt = linkhref.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
					if (matches_yt) {
						pageLinks[i].classList.add('js-open-yt');
						pageLinks[i].classList.add('video-link');
						var playArrow = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
						playArrow.innerHTML = '<use xlink:href="#t-play-arrow" />';
						pageLinks[i].append(playArrow);
					}
				}

				// add classes to vimeo links
				if (linkhref != null) {
					var matches_vim = linkhref.match(/vimeo.com\/([a-zA-Z0-9\-_]+)/);
					if (matches_vim) {
						pageLinks[i].classList.add('js-open-vimeo');
						pageLinks[i].classList.add('video-link');
						var playArrow = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
						playArrow.innerHTML = '<use xlink:href="#t-play-arrow" />';
						pageLinks[i].append(playArrow);
					}
				}
			}

			// in page links
			for (var i = 0; i < inPageLinks.length; i++) {

				// Skip all empty links AND target exists on page
				//  && !inPageLinks[i].classList.contains('show-more')
				if (inPageLinks[i].getAttribute('href') !== '#') {
					var currentLinkHref = '';
					var currentPageUrl = '';
					currentLinkHref = inPageLinks[i].getAttribute('href');
					currentPageUrl = window.location.href;

					currentLinkHref = currentLinkHref.replace(/^https?\:\/\//i, "");
					currentLinkHref = currentLinkHref.replace(/^\/\//i, "");
					currentPageUrl = currentPageUrl.replace(/^https?\:\/\//i, "");


					// Scroll to content if current href is only hash or url matches to current page url AND has hash AND current hash target exists on page
					if (
						(currentLinkHref.split('#')[0] === '' ||
							currentLinkHref.split('#')[0] === currentPageUrl.split('#')[0] ||
							currentLinkHref.split('#')[0] + '/' === currentPageUrl.split('#')[0]) &&
						document.querySelectorAll('#' + currentLinkHref.split('#')[1]).length != 0
					) {
						Utils.addEvent(inPageLinks[i], 'click', function () {
							// Use link hash as selector. If for some reason not possible, use linkhref
							var linkHref = '';
							var linkHash = '';
							linkHref = this.getAttribute('href');
							linkHash = linkHref.split('#')[1];
							var target = document.querySelector('#' + linkHash);
							target = target ? target : document.querySelector('#' + linkHref);
							// Don't scroll if show more is already open
							if (target) {
								scrollToElement(event, target);
							}
						});

					}
				}

			}

			var backButtons = document.querySelectorAll('.js-back');
			for (var i = 0; i < backButtons.length; i++) {
				if (document.referrer.indexOf(window.location.host) !== -1) {

				} else {
					backButtons[i].classList.add('is-hidden');
				}
				Utils.addEvent(backButtons[i], 'click', function (e) {
					if (document.referrer.indexOf(window.location.host) !== -1) {
						e.preventDefault();
						history.back();
					}
				});
			}


			// Login menu links rel nofollow
			/*for (var i = 0; i < extLoginLinks.length; i++) {
				if ( extLoginLinks[i].getAttribute('href') !== '#' ) {
					extLoginLinks[i].setAttribute("rel", "nofollow");
				}
			}*/



			// Welcome slider
			var welcomeSlider = document.querySelector('.welcome-slider');
			var welcomeSwiperOpts = {
				autoplay: {
					delay: 5000,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
				navigation: false,
				pagination: false,
				autoHeight: false,
				loop: true,
				speed: 500,
				effect: 'slide',
				createElements: false,
				wrapperClass: 'slider__wrapper',
				slideClass: 'slider__slide',
				slideActiveClass: 'slider__slide--active',
				slideVisibleClass: 'slider__slide--visible',
				slideNextClass: 'slider__slide--next',
				slidePrevClass: 'slider__slide--prev',
				slideDuplicateClass: 'slider__slide--duplicate',
				slideDuplicateActiveClass: 'slider__slide--duplicate-active',
				slideDuplicateNextClass: 'slider__slide--duplicate-next',
				slideDuplicatePrevClass: 'slider__slide--duplicate-prev',
				containerModifierClass: 'slider__slides--'
			}
			const welcomeSwiper = new Swiper(welcomeSlider, welcomeSwiperOpts);


			Utils.addEvent(document.querySelector('body'), 'touchstart', function (e) {
				if (e.target.closest('#swipebox-close')) {
					document.querySelector('body').classList.add('disable-header');
					setTimeout(function () {

						document.querySelector('body').classList.remove('disable-header');
					}, 1000);
				}
			});

			/*var wpAdvertsSwiperImgLink = document.querySelector('.wpadverts-swipe');

			if ( wpAdvertsSwiperImgLink ) {
				var wpAdvertsSwiperSlides = document.querySelectorAll('#swipebox-slider .slide');
				var wpAdvertsSwiperCurrentSlide = document.querySelectorAll('#swipebox-slider .current');
			}*/


			function closeAllOpenSubmenus() {
				for (let activeMenuItem of document.querySelectorAll('.menu-item.active')) {
					activeMenuItem.classList.remove('active');
				}
			}

			// Open & close submenus (mobile devices only)
			if (document.querySelector('.is-touch') && window.innerWidth >= mobileMenuBreakpoint) {

				for (var i = 0; i < submenuLinks.length; i++) {
					Utils.addEvent(submenuLinks[i], 'click', function (e) {

						if (this.parentElement.classList.contains('active')) {
							this.parentElement.classList.remove('active');
						} else {
							e.preventDefault();
							this.parentElement.classList.add('active');
						}

					});
				}
			}
			Utils.addEvent(document.querySelector('body'), 'click', function (e) {
				if (!e.target.closest('.menu-item-has-children')) {
					closeAllOpenSubmenus();
				}
			});


			baguetteBox.run('.js-image-link');
			baguetteBox.run('.gallery', {
				//animation: 'fadeIn'
			});



			/*const facebookCountEl = document.querySelector('.facebok-button--count');
			const facebookShareEl = document.querySelector('.js-facebook-share');
			if ( facebookCountEl && facebookShareEl ) {
				setTimeout(function() {

					console.log(facebookShareEl.querySelector('iframe').contentWindow.document);
					const iFrame = facebookShareEl.querySelector('iframe').contentWindow.document;
					const shareCountEl = iFrame.querySelector('#icon-button div span:last-child');
					const shareCount = shareCountEl.textContent;
					const shareCountNum = parseInt(shareCount);

					console.log(shareCountNum);
				}, 1500);

				var request = new XMLHttpRequest();
				request.open('POST', ajax_fb_share_count.ajaxurl, true);
				request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

				request.onload = function () {
					if (this.status >= 200 && this.status < 400) {
						const responseText = this.responseText;
						console.log(responseText);
					} else {
						console.log('Error');
					}
				};
				request.onerror = function() {
					console.log('connection error');
				};
				request.send('action=fb_share_count&url=https://autotori24.fi');

			}*/

			// open social sharing window
			var socialWindowOpen = document.querySelectorAll('.js-social-window');
			for (var i = 0; i < socialWindowOpen.length; i++) {
				Utils.addEvent(socialWindowOpen[i], 'click', function (event) {
					event.preventDefault();

					if (navigator.share && !window.matchMedia('(pointer:fine)').matches && this.classList.contains('facebook-button')) {

						navigator.share({
							url: this.getAttribute("data-href"),
							title: this.getAttribute("data-title"),
						})
							.then(() => { console.log("Shared YEEEE!!!!!"); })
							.catch((error) => { console.log("Sharing Failed") });

					} else {
						window.open(this.getAttribute("href"), "popupWindow", "width=600,height=600,scrollbars=yes");
					}



				});
			}


			// Close modal
			var modalCloseLinks = document.querySelectorAll('.js-close-modal');
			var modals = document.querySelectorAll('.js-modal');
			for (var i = 0; i < modalCloseLinks.length; i++) {
				Utils.addEvent(modalCloseLinks[i], 'click', function (e) {
					document.querySelector('body').classList.remove('lockscroll');
					closeModals();
					e.preventDefault();
				});
			}

			// Yt-modals close from bg click
			Utils.addEvent(document.querySelector('.js-video-modal'), 'click', function (e) {
				document.querySelector('body').classList.remove('lockscroll');
				closeModals();

				e.preventDefault();
			});

			function closeModals() {
				for (var j = 0; j < modals.length; j++) {
					modals[j].classList.remove('is-open');
					if (modals[j].classList.contains('js-video-modal')) {
						modals[j].querySelector('.js-video-modal .modal__content').innerHTML = "";
						document.querySelector('.js-open-search').setAttribute('aria-expanded', 'false');
					}
				}
			}

			// Youtube modals
			var youtubePlayLinks = document.querySelectorAll('.js-open-yt');
			for (var i = 0; i < youtubePlayLinks.length; i++) {
				Utils.addEvent(youtubePlayLinks[i], 'click', function (e) {
					if (!document.querySelector('.js-video-modal').classList.contains('is-open')) {
						var url = new URL(this.getAttribute('href'));
						var vid = url.searchParams.get("v");
						document.querySelector('body').classList.add('lockscroll');
						document.querySelector('.js-video-modal').classList.add('is-open');
						document.querySelector('.js-video-modal').classList.add('modal--player');
						document.querySelector('.js-video-modal .modal__content').innerHTML = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + vid + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
					}
					e.preventDefault();
				});
			}
			// Vimeo modals
			var vimeoPlayLinks = document.querySelectorAll('.js-open-vimeo');
			for (var i = 0; i < vimeoPlayLinks.length; i++) {
				Utils.addEvent(vimeoPlayLinks[i], 'click', function (e) {
					if (!document.querySelector('.js-video-modal').classList.contains('is-open')) {
						var url = new URL(this.getAttribute('href'));
						var vid = url.pathname;
						document.querySelector('body').classList.add('lockscroll');
						document.querySelector('.js-video-modal').classList.add('is-open');
						document.querySelector('.js-video-modal').classList.add('modal--player');
						document.querySelector('.js-video-modal .modal__content').innerHTML = '<iframe src="https://player.vimeo.com/video' + vid + '?title=0&byline=0&portrait=0" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
					}
					e.preventDefault();
				});
			}

			// Search modal
			Utils.addEvent(document.querySelector('.js-open-search'), 'click', function (e) {
				if (!document.querySelector('.js-search-modal').classList.contains('is-open')) {
					this.setAttribute('aria-expanded', 'true');
					document.querySelector('body').classList.add('lockscroll');
					document.querySelector('.js-search-modal').classList.add('is-open');
					setTimeout(function () {
						document.querySelector('.js-search-modal .search-field').focus();
					}, 500);
				}
				e.preventDefault();
			});



			// Yritykset random ads
			function getYritysdAs(container) {
				var num_posts = container.getAttribute('data-num-posts');

				// All ids related to current loop
				var ids = document.querySelector('#featured-yritykset').getAttribute('value');
				// To array
				var idsarr = ids.split(",").map(x => +x);
				// Shuffle the ids in array to make result random
				shuffle(idsarr);
				// Take only 6 from beginning. Results in 6 random posts from all featureds available
				idsarr = idsarr.slice(0, num_posts);
				var idstext = idsarr.toString();
				//console.log(idstext);

				var request = new XMLHttpRequest();
				request.open('POST', ajax_yritykset_ads_random.ajaxurl, true);
				request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

				request.onload = function () {
					if (this.status >= 200 && this.status < 400) {
						container.innerHTML = this.responseText;
					} else {
						console.log('Error');
					}
				};
				request.onerror = function () {
					console.log('connection error');
				};
				request.send('action=yritykset_ads_random&yritys_ids=' + idstext + '&num_posts=' + num_posts);


			}
			var yrityksetContainers = document.querySelectorAll('.yritykset__featured-container');
			for (var y = 0; y < yrityksetContainers.length; y++) {
				getYritysdAs(yrityksetContainers[y]);
			}






			var debounce = function (func, wait, immediate) {
				var timeout;
				return function () {
					var context = this, args = arguments;
					clearTimeout(timeout);
					timeout = setTimeout(function () {
						timeout = null;
						if (!immediate) func.apply(context, args);
					}, wait);
					if (immediate && !timeout) func.apply(context, args);
				};
			};

			// debounced resize event
			var resizeDebounce = debounce(function () {
				fixVideos();
			}, 100);
			window.addEventListener('resize', resizeDebounce);


			// scroll function
			var scrollDebounce = debounce(function () {
				checkHeaderPos();
			}, 10);
			window.addEventListener('scroll', scrollDebounce);

		},
		finalize: function () {
			// JavaScript to be fired on all pages, after page specific JS is fired
		}
	},
	// Home page
	'home': {
		init: function () {
			// JavaScript to be fired on the home page
		},
		finalize: function () {
			// JavaScript to be fired on the home page, after the init JS
		}
	}
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
	fire: function (func, funcname, args) {
		var fire;
		var namespace = Base;
		funcname = (funcname === undefined) ? 'init' : funcname;
		fire = func !== '';
		fire = fire && namespace[func];
		fire = fire && typeof namespace[func][funcname] === 'function';

		if (fire) {
			namespace[func][funcname](args);
		}
	},
	loadEvents: function () {
		// Fire common init JS
		UTIL.fire('common');

		// Fire page-specific init JS, and then finalize JS
		var pageClasses = document.body.className.replace(/-/g, '_').split(/\s+/);
		for (var iP = 0; iP < pageClasses.length; iP++) {
			UTIL.fire(pageClasses[iP]);
			UTIL.fire(pageClasses[iP], 'finalize');
		}

		// Fire common finalize JS
		UTIL.fire('common', 'finalize');
	}
};

// Load Events
document.addEventListener('DOMContentLoaded', UTIL.loadEvents);
